module.exports = new __parcel__URL__("EmptyStateImageLight.6df2a248.svg").toString();